
import { Component, Vue, Ref } from 'vue-property-decorator'
import PhoneExamineTable, { ExamineOption } from './components/phoneExamineTable.vue'
import { MediaService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'phone-examine-table',
    components: {
        PhoneExamineTable,
        ScrollTo
    }
})
export default class extends Vue {
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private status = 0
    private statusOpitons = [
        { key: 0, value: '全部' },
        { key: 1, value: '未处理' },
        { key: 2, value: '正确' },
        { key: 3, value: '错误' }
    ]
    private isLoading = true
    private phoneList = []
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getPhoneList)
    }

    private async mounted() {
        await this.getPhoneList()
    }

    private async getPhoneList() {
        this.isLoading = true
        const status = this.status || undefined
        const params = {
            status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await MediaService.getPhoneList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.phoneList = result.data.list
        }
        this.isLoading = false
    }

    private async onPhoneExamine({ status, target }: ExamineOption) {
        const params = { id: target.id, status }
        const result = await MediaService.updatePhoneStatus(params)
        if (result.status === 200) {
            target.status = status
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误，修改失败',
            showClose: true
        })
    }
}
